<template>
  <div>
    <section class="section-pad">
      <div class="section-content">
        <el-row type="flex" justify="center">
          <el-col :lg="20">
            <div class="our-clients">
              <swiper :options="swiperOption" ref="swiperTop">
                <swiper-slide v-for="(item, index) in ourClients" :key="index" class="each-client">
                  <router-link
                    :to="{ name: 'search-products', query: { brand: item.brand_name }}"
                    class="client-img"
                  >
                    <img :src="'/our-clients/'+item.image" :alt="item.brand_name" class="image" />
                  </router-link>
                </swiper-slide>
              </swiper>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ourClients: [
        {
          id: 1,
          image: "apple_logo1.png",
          brand_name: "apple"
        },
        {
          id: 2,
          image: "beats_logo.png",
          brand_name: "beats"
        },
        {
          id: 3,
          image: "lifx_logo.png",
          brand_name: "lifx"
        },
        {
          id: 4,
          image: "ring_logo.png",
          brand_name: "ring"
        },
        {
          id: 5,
          image: "moyork_logo.png",
          brand_name: "moyork"
        },
        {
          id: 6,
          image: "jabra_logo.png",
          brand_name: "jabra"
        },
        {
          id: 7,
          image: "cygnett_logo.png",
          brand_name: "cygnett"
        },
        {
          id: 8,
          image: "kaiser_bass_logo.png",
          brand_name: "kaiser bass"
        },
        {
          id: 9,
          image: "stm_logo.png",
          brand_name: "stm"
        }
      ],
      title: "details",
      loading: false,
      swiperOption: {
        initialSlide: 0,
        spaceBetween: 40,
        speed: 900,
        autoplay: {
          delay: 2000
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        loop: true,
        disableOnInteraction: false,
        centeredSlides: false,
        slidesPerView: "4",
        slideToClickedSlide: false
      }
    };
  }
};
</script>

<style scoped lang="scss">
.our-clients {
  background: #f9f9f9;
  padding: 0.5em 1.5em;
  border-radius: 6.25em 0;
  .each-client {
    .client-img {
      display: block;
      margin: 0 auto;
      img {
        display: block;
        margin: 0 auto;
        width: 150px;
        filter: grayscale(100%);
        transition: 0.5s ease-in-out;
        &:hover {
          filter: grayscale(0);
        }
      }
    }
  }
}
</style>
